import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { ClassesEmptyState } from 'modules/trainings/components/Revamp/TrainingsDetail/Classes/EmptyState'
import { GroupsDataTable } from 'modules/trainings/components/Revamp/TrainingsDetail/GroupsDataTable'
import { DetailOutletContext } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

export default function ClassesTab() {
  const { id } = useParams()
  const { classes, training, canEdit, hasDevTrainings } = useOutletContext<DetailOutletContext>()

  return (
    <>
      {(classes || []).length === 0 ? (
        <ClassesEmptyState trainingId={Number(id)} />
      ) : (
        <GroupsDataTable />
      )}
      <Outlet context={{ classes, training, canEdit, hasDevTrainings }} />
    </>
  )
}
